import { StatChartSpec, statChartSpecSchema } from '@/core';
import { createVisualization, mapPropsToSpec, mapSpecToProps } from '@/plugin-system';
import { StatChartIcon } from './StatChartIcon';
import { StatChartOptionsEditorSettings } from './StatChartOptionsEditorSettings';
import { StatChartPanel } from './StatChartPanel';
import {
  createInitialStatChartOptions,
  STAT_CHART_DATA_TYPES,
  STAT_CHART_PROP_TO_SPEC_MAPPING,
  StatChartColorScheme,
} from './stat-chart-model';

export const StatChart = createVisualization(StatChartPanel, {
  vizConfig: {
    noPadding: true,
  },
  dashboardConfig: {
    kind: 'StatChart',
    mapSpecToProps: (spec) => {
      const mappedProps = mapSpecToProps(spec, STAT_CHART_PROP_TO_SPEC_MAPPING);
      // set colorScheme to 'thresholds' so that the text and sparkline colors are always derived from thresholds in dashboards
      return { ...mappedProps, colorScheme: StatChartColorScheme.THRESHOLDS };
    },
    mapPropsToSpec: (props) => mapPropsToSpec(props, STAT_CHART_PROP_TO_SPEC_MAPPING),
    panelOptionsEditorComponents: [
      {
        label: 'Settings',
        content: StatChartOptionsEditorSettings,
      },
    ],
    createInitialOptions: createInitialStatChartOptions,
    enableCompareMode: true,
    schema: statChartSpecSchema,
    supportedDataType: STAT_CHART_DATA_TYPES,
    mapSpecToDataType: (spec: StatChartSpec) => {
      if (spec.sparkline) return 'SingleValueTimeSeries';
      return 'SingleValue';
    },
    icon: StatChartIcon,
  },
});

export type StatChartVizProps = React.ComponentProps<typeof StatChart.Viz>;
export type StatChartVizBaseProps = React.ComponentProps<typeof StatChart.VizBase>;
